import type { ChakraStylesConfig, GroupBase } from 'chakra-react-select';
import type { StylesConfig } from 'react-select';

export const menuPortalStyles: StylesConfig<
  // biome-ignore lint/suspicious/noExplicitAny: matches BaseSelectStyles
  any,
  boolean,
  // biome-ignore lint/suspicious/noExplicitAny: matches BaseSelectStyles
  GroupBase<any>
> = {
  menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
};

export const BaseSelectStyles: ChakraStylesConfig<
  // biome-ignore lint/suspicious/noExplicitAny: migrated from develop
  any,
  boolean,
  // biome-ignore lint/suspicious/noExplicitAny: migrated from develop
  GroupBase<any>
> = {
  container: (provided) => ({
    ...provided,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: 0,
    gap: '8px',
    boxSizing: 'border-box',
    width: '100%',
    height: '32px',
    background: 'var(--ccp-rs-control-bg, #FFFFFF)',
    border: '1px solid var(--ccp-rs-border, #E2E8F0)',
    borderRadius: '4px',
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: 'var(--ccp-rs-menu-bg, #FFFFFF)',
  }),
  control: (provided) => ({
    ...provided,
    minHeight: '32px',
    height: '32px',
    background: 'transparent',
    borderWidth: 0,
    boxShadow: 'none',
    padding: 0,
  }),
  valueContainer: (provided) => ({
    ...provided,
    fontSize: '14px',
    padding: 0,
    paddingLeft: '8px',
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    padding: 0,
  }),
  clearIndicator: (provided) => ({
    ...provided,
    width: '16px',
    height: '16px',
    '> svg': {
      width: '8px',
      height: '8px',
    },
  }),
  group: (provided) => ({
    ...provided,
    ':not(:last-of-type)': {
      marginBottom: '12px',
      paddingBottom: '12px',
      boxShadow: '0px 24px 3px -24px #CDD7EA',
    },
  }),
  groupHeading: (provided) => ({
    ...provided,
    fontSize: '14px',
    color: 'navyBlue.300',
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused
      ? 'var(--ccp-rs-option-hover, #DEF5EE)'
      : 'transparent',
    fontSize: '14px',
    color: 'text.primary',
    ':active': {
      backgroundColor: 'var(--ccp-rs-option-hover, #DEF5EE)',
      color: 'var(--ccp-rs-text, #000)',
    },
  }),
};
